module.exports = __webpack_public_path__ + "712e249ea37b664322ec31212a16126b.png";